import React from 'react';
import {
  PayrollEmployeeCompensationDetails,
  SelfOnboardingCompensationStructure,
} from 'api/gql-utils/employeeOnboardingGql/types';
import { SalaryPreviewTable, SalaryPreviewTableData } from './SalaryPreviewTable';
import useFeature from 'hooks/useFeature';
import {
  customSalaryStructureDefaultComponentsWithoutNps,
  customSalaryStructureDefaultComponentsWithNps,
} from './constants';

export const CustomSalaryStructurePreview = ({
  compensationDetails,
}: {
  compensationDetails: PayrollEmployeeCompensationDetails | undefined;
}) => {
  const { isNpsFlagEnabled } = useFeature('npsFlag');
  const earnings = compensationDetails?.earnings;

  const customSalaryStructureDefaultComponents = isNpsFlagEnabled
    ? customSalaryStructureDefaultComponentsWithNps
    : customSalaryStructureDefaultComponentsWithoutNps;

  const components: SalaryPreviewTableData[] = customSalaryStructureDefaultComponents
    .filter(({ id }) => {
      return earnings
        ? earnings[id as keyof SelfOnboardingCompensationStructure] !== undefined
        : true;
    })
    .map((component) => ({
      id: component.id,
      name: component.name,
      monthlyAmount:
        Number(earnings?.[component.id as keyof SelfOnboardingCompensationStructure]) ?? 0,
      annualAmount:
        (Number(earnings?.[component.id as keyof SelfOnboardingCompensationStructure]) ?? 0) * 12,
    }));

  const customAllowances: SalaryPreviewTableData[] =
    earnings?.customAllowances?.map((allowance) => ({
      id: allowance.name,
      name: allowance.name,
      monthlyAmount: Number(allowance.amount) ?? 0,
      annualAmount: (Number(allowance.amount) ?? 0) * 12,
    })) || [];

  const tableData = [...components, ...customAllowances];

  return <SalaryPreviewTable tableData={tableData} />;
};
